export enum PresenceState {
  Unknown = 'Unknown',
  Yes = 'Yes',
  No = 'No',
}
